<template>
  <a-drawer
    placement="right"
    :visible="visible"
    title="锁定记录"
    width="50%"
    @close="onClose"
  >
    <a-form label-width="100">
      <div class="header-component">
        <a-form-item
          v-for="(item) in orderInfoFileds"
          :key="item.prop"
          :label="item.label"
          class="form-item"
        >
          <span class="content_text">{{ item.formatter ? item.formatter(orderInfo) : orderInfo[item.prop] }}</span>
        </a-form-item>
      </div>
    </a-form>
    <div class="table_header">
      <div class="flex_1">
        预占详情
      </div>
      <div>锁定量合计：{{ orderInfo.lockedAmount }}</div>
    </div>
    <a-table
      :loading="loading.setRecords"
      :columns="tableColumns"
      :data-source="records"
      class="table-sigle"
      row-key="id"
      :scroll="{ x: 'calc(0 + 50%)'}"
      > 
    </a-table>
    <div class="footer">
        <a-button @click="onClose">
         关 闭
        </a-button>
      </div>
  </a-drawer>
</template>
<script>
import { searchBatchStockLocked } from '../../api';
import { orderInfoFileds, tableColumns } from '../constant';

export default {
  data() {
    return {
      visible: false,
      orderInfo: {},
      orderInfoFileds,
      records: [],
      tableColumns,
      loading: {
        setRecords: false,
      },
    };
  },
  methods: {
    open(info) {
      this.visible = true;
      this.orderInfo = { ...info };
      this.setRecords();
    },
    async setRecords() {
      this.records = await searchBatchStockLocked({
        goodsId: this.orderInfo.goodsId,
        storehouseId: this.orderInfo.locationId,
        batchNo: this.orderInfo.batchNo,
        goodsQuality: this.orderInfo.goodsQualityCode,
        warehouseCode: this.orderInfo.warehouseCode,
      });
    },
    onClose() {
      this.orderInfo = {};
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.header-component {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  .ant-form-item{
    width: 50%;
    display:flex;
    align-items: center;
    .content_text{
      font-weight: 600;
      color: #171717;
    }
   ::v-deep .ant-form-item-label{
      width: 120px;
    }
  }
}

.margin-bottom-16 {
  margin-bottom: 16px;
}

.table-input {
  display: flex;
  align-items: center;

  .el-form-item {
    margin-bottom: 0;
  }

  .el-input-number {
    width: 60px;
  }
}

.width-100 {
  width: 100%;
}

.footer {
  bottom: 0;
  position: absolute;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

.table_header {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
</style>
